import { Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../components/Button";
import { CancelButton } from "../../../../Settings/components/SecurityModal/SecurityModal.styles";
import {
  ButtonContainer,
  confirmModalCss,
  ContentContainer,
} from "./DeleteAppointmentModal.styles";

type DeleteAppointmentModalProps = {
  onClose(confirm: boolean): void;
};

export function DeleteAppointmentModal({
  onClose,
}: DeleteAppointmentModalProps) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmDelete = () => {
    setIsLoading(true);
    onClose(true);
  };

  const handleCancel = () => {
    onClose(false);
  };

  return (
    <Modal
      title={t("appointments_cancelModal_title")}
      open
      zIndex={3001}
      maskStyle={{ pointerEvents: "all" }}
      footer={null}
      width={500}
      onCancel={handleCancel}
      className={confirmModalCss()}
      centered
      destroyOnClose
    >
      <ContentContainer>
        <p
          style={{
            padding: "18px 0 0 0",
            fontWeight: "400",
            color: "#939393",
            marginLeft: "5px",
          }}
        >
          Are you sure you want to cancel this appointment?
        </p>
        <ButtonContainer>
          <Button
            label={t("appointments_cancelModal_confirm")}
            type="button"
            onClick={handleConfirmDelete}
            isLoading={isLoading}
          />

          <CancelButton isModal onClick={handleCancel}>
            {t("common_cancel")}
          </CancelButton>
        </ButtonContainer>
      </ContentContainer>
    </Modal>
  );
}
